import api from '../api';
import { serviceReutils } from '../../utils/reutils';

export const ServiceVinculada = {
  ...serviceReutils({ name: 'rotas/v1/agencia', api }),
};
